"use strict";Object.defineProperty(exports, "__esModule", {value: true});/*!
 * name: @jswork/fetch-with-timeout
 * description: Fetch with timeout support, enhancing request control and compatibility.
 * homepage: https://js.work
 * version: 1.0.0
 * date: 2025-05-24 10:02:09
 * license: MIT
 */



// src/index.ts
var TimeoutError = class extends Error {
  constructor(message = "Request timed out") {
    super(message);
    this.name = "TimeoutError";
  }
};
function fetchWithTimeout(url, options = {}) {
  const { timeout, timeoutMessage, ...fetchOptions } = options;
  if (timeout !== void 0 && timeout <= 0) {
    throw new Error("Timeout must be a positive number");
  }
  if (!timeout) {
    return fetch(url, fetchOptions);
  }
  const timeoutPromise = new Promise((_, reject) => {
    setTimeout(() => {
      reject(new TimeoutError(timeoutMessage));
    }, timeout);
  });
  return Promise.race([fetch(url, fetchOptions), timeoutPromise]);
}
var index_default = fetchWithTimeout;



exports.TimeoutError = TimeoutError; exports.default = index_default;
